import { render, staticRenderFns } from "./VerificationRerequestModal.vue?vue&type=template&id=5d438ffb"
import script from "./VerificationRerequestModal.vue?vue&type=script&lang=ts"
export * from "./VerificationRerequestModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports